import { toPercent } from "../../utility/Utils";

export const subCategTableData = (values, language) => {
    if (!values) return [];
    return values.map((item) => ({
        name: item[`${'text-' + language}`],
        transactions: item.sales_nbr,
        clicks: item.clics,
        rate: toPercent(item.conversions_rate ? item.conversions_rate * 100 : 0),
    }));
};

export const influencerTableData = (values) => {
    if (!values) return [];
    return values.map((item) => ({
        name: item.influencer,
        transactions: item.sales_nbr,
        clicks: item.clics,
        rate: toPercent(item.conversions_rate ? item.conversions_rate * 100 : 0),
        uid: item.influencer_id,
    }));
};

export const socialMediaTableData = (values) => {
    if (!values) return [];
    return values
        .filter((s) => s.socialMedia)
        .map((item) => ({
            name: item.socialMedia,
            transactions: item.sales_nbr,
            clicks: item.clics,
            rate: toPercent(item.conversions_rate ? item.conversions_rate * 100 : 0),
        }));
};
